import { useState } from 'react';
import { CONTENT_FRAME_ID } from '../appTemplate.consts';

const findContentFrame = () =>
  typeof document === 'undefined' ? null : document.getElementById(CONTENT_FRAME_ID);

export const useContentFrameScrollParent = () => {
  const [scrollParent] = useState<HTMLElement | null>(findContentFrame);
  return scrollParent;
};
